import { gql } from 'apollo-angular';

export const FilterProjectsDocument = gql(/* GraphQL*/ `query filterProjects($input: FilterInputGraphql!)
{
  filterProjects(input: $input)
  {
    records{
      name,
      id
    },
    total
  }
}

`);
